<template>
<div>
 <header class="headerUser" style="z-index: 8 !important;" id="headerMenubarUser">
    <nav class="headerUser__nav" >
      <ul class="headerUser__navbar">
        <li class="headerUser__item">
          <a  class="headerUser__link">
            <button class="headerUser--btn" key="off" @click="show = !show">
                  <v-icon  class="headerUser--icon">more_vert</v-icon>
              </button>
          </a>
          <transition name="dropdown"  v-if="detail.statemember == 'active' && detail.type=='user'">
            <div class="headerUser__dropdown-menu" v-bind:class="{ active: show }" v-if="show">
              <ul class="headerUser__dropdown-menu-nav">

                <li class="headerUser__dropdown-menu-item" @click="opentask()">
                  <a  class="headerUser__dropdown-menu-link">
                    <div class="headerUser__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">fas fa-tasks</v-icon>
                    </div>
                    <div class="headerUser__dropdown-menu-text">
                      {{$t('RightSide.menu.project')}}
                    </div>
                  </a>
                </li>
                <hr>
                <li class="headerUser__dropdown-menu-item" @click="openalbum()">
                  <a  class="headerUser__dropdown-menu-link">
                    <div class="headerUser__dropdown-menu-svg">
                      <v-icon meduim class="headerUser--icon--menu">fas fa-images</v-icon>
                    </div>
                    <div class="headerUser__dropdown-menu-text">
                      {{$t('RightSide.menu.album')}}
                    </div>
                  </a>
                </li>

                <li class="headerUser__dropdown-menu-item"   @click="opennotes()">
                  <a  class="headerUser__dropdown-menu-link">
                    <div class="headerUser__dropdown-menu-svg">
                      <v-icon meduim class="headerUser--icon--menu">fas fa-sticky-note</v-icon>
                    </div>
                    <div class="headerUser__dropdown-menu-text">
                      {{$t('RightSide.menu.note')}}
                    </div>
                  </a>
                </li>
                <li class="headerUser__dropdown-menu-item" @click="clearchat()">
                  <a  class="headerUser__dropdown-menu-link">
                    <div class="headerUser__dropdown-menu-svg">
                      <v-icon meduim class="headerUser--icon--menu">fas fa-trash</v-icon>
                    </div>
                    <div class="headerUser__dropdown-menu-text">
                      {{$t('RightSide.menu.clearChat')}}
                    </div>
                  </a>
                </li>
                <hr>
                <li class="headerUser__dropdown-menu-item" @click="openwallpaper()">
                  <a  class="headerUser__dropdown-menu-link">
                    <div class="headerUser__dropdown-menu-svg">
                      <v-icon meduim class="headerUser--icon--menu">fas fa-images</v-icon>
                    </div>
                    <div class="headerUser__dropdown-menu-text">
                      {{$t('RightSide.menu.setwall')}}
                    </div>
                  </a>
                </li>
                 <hr>
                <li class="headerUser__dropdown-menu-item" @click="blockfriend(detail.data_room[0].tokenuser,detail.data_room[0].name)">
                  <a  class="headerUser__dropdown-menu-link">
                    <div class="headerUser__dropdown-menu-svg">
                      <v-icon meduim class="headerUser--icon--menu">mdi-block-helper</v-icon>
                    </div>
                    <div class="headerUser__dropdown-menu-text">
                      {{$t('RightSide.menu.block')}}
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </transition>
          <transition name="dropdown" v-else-if="detail.statemember == 'active' && detail.type=='group'">
            <div class="header__dropdown-menu" v-bind:class="{ active: show }" v-if="show">
              <ul class="header__dropdown-menu-nav">
                <li class="header__dropdown-menu-item" @click="openQRcode()">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">mdi-qrcode</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{$t('RightSide.menu.qrCode')}}
                    </div>
                  </a>
                </li>
                 <hr>
                 <li class="header__dropdown-menu-item" @click="opentask()">
                   <a  class="header__dropdown-menu-link">
                     <div class="header__dropdown-menu-svg">
                       <v-icon meduim class="header--icon--menu">fas fa-tasks</v-icon>
                     </div>
                     <div class="header__dropdown-menu-text">
                      {{$t('RightSide.menu.project')}}
                     </div>
                   </a>
                 </li>
                 <hr>
                <li class="header__dropdown-menu-item" @click="openalbum()">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">fas fa-images</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{$t('RightSide.menu.album')}}
                    </div>
                  </a>
                </li>

                <li class="header__dropdown-menu-item"   @click="opennotes()">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">fas fa-sticky-note</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{$t('RightSide.menu.note')}}
                    </div>
                  </a>
                </li>
                 <li class="header__dropdown-menu-item" v-for="(item, index) in listMenu" :key="index" v-on:click="ShowDialog(item.dialog)">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">{{item.icon}}</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{ item.title }}
                    </div>
                  </a>
                </li>
                <li class="header__dropdown-menu-item" @click="clearchat()">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">fas fa-trash</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{$t('RightSide.menu.clearChat')}}
                    </div>
                  </a>
                </li>
                <hr>
                <li class="header__dropdown-menu-item" @click="openwallpaper()">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">fas fa-images</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{$t('RightSide.menu.setwall')}}
                    </div>
                  </a>
                </li>
                 <hr>
                <li class="header__dropdown-menu-item" @click="leavegroup()">
                  <a  class="header__dropdown-menu-link">
                    <div class="header__dropdown-menu-svg">
                      <v-icon meduim class="header--icon--menu">call_missed_outgoing</v-icon>
                    </div>
                    <div class="header__dropdown-menu-text">
                      {{$t('RightSide.menu.leave')}}
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </transition>
          <transition name="dropdown" v-else>
            <div class="headerOut__dropdown-menu" v-bind:class="{ active: show }" v-if="show">
              <ul class="headerOut__dropdown-menu-nav">
                <li class="headerOut__dropdown-menu-item" @click="clearchat()">
                  <a  class="headerOut__dropdown-menu-link">
                    <div class="headerOut__dropdown-menu-svg">
                      <v-icon meduim class="headerOut--icon--menu">fas fa-trash</v-icon>
                    </div>
                    <div class="headerOut__dropdown-menu-text">
                      {{$t('RightSide.menu.clearChat')}}
                    </div>
                  </a>
                </li>
                <hr v-if="detail.statemember == 'block'">
               <li v-if="detail.statemember == 'block'" class="header__dropdown-menu-item" @click="unBlock(detail.data_room[0])">
                 <a  class="header__dropdown-menu-link">
                   <div class="header__dropdown-menu-svg">
                     <v-icon meduim class="header--icon--menu">mdi-lock-open</v-icon>
                   </div>
                   <div class="header__dropdown-menu-text">
                     {{$t('RightSide.menu.unblock')}}
                   </div>
                 </a>
               </li>
              </ul>
            </div>
          </transition>
        </li>
      </ul>
    </nav>
  </header>

</div>
</template>

<script>

import {sync} from 'vuex-pathify'
import { Decode, Momenttime } from '@/services'
// import '/static/style/menu.scss'

export default {
  props: {
    detail: {}
  },
  data: () => ({
    // shownotes: false,
    // showalbum: false,
    token: '',
    text_project: '',
    show: false,
    listMenu: []
  }),
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
    var me = this
    $(document).click(function(event) {
      var target = $(event.target);
      if(!target.closest('#headerMenubarUser').length && $('#headerMenubarUser').is(":visible")) {
        me.show = false
      }
    })
  },
  methods: {
    // check_project_room () {
    //   this.axios.post(process.env.APIpub + '/v1/user/get_project_by_tokenroom', {
    //     tokenuser: this.token,
    //     tokenroom: this.$route.params.roomid
    //   }).then((response) => {
    //     // console.log(response.data)
    //     if (response.data.status === 'success') {
    //       this.text_project = 'ดูโปรเจค'
    //     } else {
    //       this.text_project = 'สร้างโปรเจค'
    //     }
    //   }).catch(error => {
    //     console.log(error.message)
    //     // if (error.message == 'Request failed with status code 404') {
    //     //   this.text_project = 'สร้างโปรเจค'
    //     // }
    //   })
    // },
    unBlock (item) {
      // console.log(item)
      item.tokenroom = this.$route.params.roomid
      this.show = false
      this.$emit('unblock', item)
    },
    setListMenu () {
      this.listMenu = [{
        icon: 'group_add',
        title: this.$t('RightSide.menu.invite'),
        dialog: 'Invite',
        color: 'gray'
      },
      {
        icon: 'settings',
        title: this.$t('RightSide.menu.setting'),
        dialog: 'ManageGroup',
        color: 'gray'
      }]
    },
    opentask () {
      this.show = false
      this.$router.push('/chat/room/project/' + this.$route.params.roomid)
    },
    openalbum () {
      this.show = false
      this.$emit('openalbum', true)
    },
    opennotes () {
      this.show = false
      this.$emit('opennotes', true)
    },
    blockfriend (tokenuser,name) {
      this.show = false
      this.$emit('blockfriend', tokenuser, name)
    },
    openQRcode () {
      this.show = false
      this.$emit('openQRcode', true)
    },
    openwallpaper () {
      this.show = false
      this.$emit('openWallpaper', true)
    },
    ShowDialog(dialog) {
      this.show = false
      this.$emit('ShowDialog', dialog)
    },
    leavegroup () {
      this.show = false
      this.$emit('leavegroup')
    },
    clearchat () {
      this.show = false
      this.$swal({
        text: this.$t('Alert.Right.clearChat'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.chIsactive = this.$route.params.roomid
        }
      })
    },
  },
  computed: {
    ...sync('*')
  },
  watch: {
    '$i18n.locale' () {
      this.setListMenu()
    },
    block_friend (data) {
      // console.log(data)
      if (data.event === 'unblock_friend') {
        this.detail.statemember = 'active'
      } else {
        this.detail.statemember = 'block'
      }
    },
  },
  created() {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.setListMenu()
    // this.check_project_room()
  },
  components: {
  }
}
</script>

<style lang="css" scoped>
/*@import 'static/style/menu.css';*/

.headerOut__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  max-height: 8rem;
  min-width: 200px;
  overflow-y: auto;
  padding: 1rem 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
}
.headerOut__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
}
.headerOut__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.headerOut__dropdown-menu-link:hover .headerOut--icon--menu {
  color: #2562af;
}
.headerOut__dropdown-menu-svg {
  padding-right: 16px;
}
.headerOut__dropdown-menu-svg.headerOut--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.headerOut__dropdown-menu-svg.headerOut--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}


.header__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  /* height: 25rem; */
  height: 28rem;
  min-width: 215px;
  overflow-y: auto;
  padding: 1rem 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
}
.header__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
}
.header__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.header__dropdown-menu-link:hover .header--icon--menu {
  color: #2562af;
}
.header__dropdown-menu-svg {
  padding-right: 16px;
}
.header__dropdown-menu-svg.header--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.header__dropdown-menu-svg.header--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}


.headerUser {
  margin-top: 15px;
}

.headerUser__nav {
  position: relative;
}
.headerUser__navbar {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.headerUser__item {
  padding: 1rem;
  position: relative;
}
.headerUser--icon {
  font-size: 20px;
  color: white !important;
}
.headerUser--icon--menu {
  color: gray;
}
.headerUser--btn {
  top: 0;
  right: 0;
  position: absolute;
}
.headerUser--btn:focus {
  outline:none;
}
.headerUser--icon, .headerUser--icon--menu {
  fill: currentcolor;
  width: 1.65rem;
  height: 1.65rem;
  display: inline-flex;
}
.headerUser--btn {
  cursor: pointer;
  padding: 0;
  display: inline-block;
  border: 1px solid transparent;
  background-color: transparent;
  appearance: none;
  user-select: none;
}
.headerUser__dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  /* height: 15rem; */
  height: 18rem;
  min-width: 175px;
  overflow-y: auto;
  padding: 7px 1rem 0rem 0;
  margin-top: 0rem;
  border-radius: 8px;
  background-color: white;
  border: 1px solid #dadce0;
  background-clip: padding-box;
  display: flex;
  align-items: center;
}
.headerUser__dropdown-menu-link {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  line-height: 0;
  color: #3c4043;
  padding: 0.3rem 1.5rem 0.3rem 1.5rem;
  margin-bottom: 0.4rem;
  border-radius: 0 50px 50px 0;
}
.headerUser__dropdown-menu-link:hover {
  background-color: #b4d1f478;
  color: #2562af;
}
.headerUser__dropdown-menu-link:hover .headerUser--icon--menu {
  color: #2562af;
}
.headerUser__dropdown-menu-svg {
  padding-right: 16px;
}
.headerUser__dropdown-menu-svg.headerUser--icon {
  width: 1.40rem;
  height: 1.40rem;
}
.headerUser__dropdown-menu-svg.headerUser--icon--menu {
  width: 1.40rem;
  height: 1.40rem;
}

/*// Dropdown animation*/
.dropdown-enter-active, .dropdown-leave-active {
  transition: all 0.3s;
}
.dropdown-enter, .dropdown-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
.wrapper {
  height: 70vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.wrapper.social {
  margin-top: 1rem;
}
.wrapper a {
  padding: 0.6rem;
}
.wrapper h1 {
  color: #42b983;
  font-size: 2rem;
  font-weight: 300;
}
.wrapper p {
  color: #7f8c8d;
  font-weight: 100;
}
.wrapper svg {
  fill: currentcolor;
  color: #b8c2cc;
  width: 1.65rem;
  height: 1.65rem;
  display: inline-flex;
}
ul {
  margin: 0;
  padding: 0;
}

h1 { margin: 0 }
li { list-style: none; }
a { text-decoration: none; }

hr {
  border: 0;
  height: 0;
  margin: 5px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary {
  z-index: 8 !important;
}


</style>



// WEBPACK FOOTER //
// src/components/chat/layout/RightMenuSide.vue